import { createAction } from 'redux-actions';

const ONGOING_CALL_IVR_MODAL_SHOW = 'ONGOING_CALL_IVR_MODAL_SHOW';
const ONGOING_CALL_IVR_MODAL_HIDE = 'ONGOING_CALL_IVR_MODAL_HIDE';

const showModal = createAction(ONGOING_CALL_IVR_MODAL_SHOW);
const hideModal = createAction(ONGOING_CALL_IVR_MODAL_HIDE);

export default {
  types: {
    ONGOING_CALL_IVR_MODAL_SHOW,
    ONGOING_CALL_IVR_MODAL_HIDE,
  },
  creators: {
    showModal,
    hideModal,
  },
};


// WEBPACK FOOTER //
// ./src/redux/actions/A_ongoing_call_ivr_modal.js